import React, { createContext, useContext, useEffect, useState } from 'react';

interface ChatSessionContextProps {
  sessionId: string;
  setSessionId: (id: string) => void;
  startNewSession: () => void;
}

const ChatSessionContext = createContext<ChatSessionContextProps>({
  sessionId: '',
  setSessionId: () => {},
  startNewSession: () => {},
});

export const useChatSession = () => useContext(ChatSessionContext);

export const ChatSessionProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [sessionId, setSessionId] = useState('');

  useEffect(() => {
    const role = localStorage.getItem('tara_user_role')?.toLowerCase();
    if (!role) return;

    const saved = localStorage.getItem(`tara_active_session_${role}`);
    if (saved) {
      setSessionId(saved);
    }
  }, []);

  const startNewSession = () => {
    const newId = `session_${Date.now()}_${Math.random()
      .toString(36)
      .slice(2, 8)}`;
    const role = localStorage.getItem('tara_user_role')?.toLowerCase();

    if (!role) return;

    setSessionId(newId);
    localStorage.setItem(`tara_active_session_${role}`, newId);
    const key = `tara_chat_sessions_${role}`;
    const newSessionId = `session_${Date.now()}`;
    const existing = JSON.parse(localStorage.getItem(key) || '[]');
    existing.push({
      sessionId: newSessionId,
      createdAt: Date.now(),
      messages: [],
    });
    localStorage.setItem(key, JSON.stringify(existing));
  };

  return (
    <ChatSessionContext.Provider
      value={{ sessionId, setSessionId, startNewSession }}
    >
      {children}
    </ChatSessionContext.Provider>
  );
};
